module.exports = __webpack_public_path__ + "img/logo.d16832c2.webp";